<script lang="ts">
  import { messages } from '@/stores/messages';

  interface Props {
    open: boolean;
    targetType: 'Message' | 'User' | 'Post' | 'Comment';
    targetId: string;
    label?: string;
    onClose: () => void;
    onSubmitted?: () => void;
  }

  let { open = $bindable(), targetType, targetId, label, onClose, onSubmitted }: Props = $props();

  const REASONS: { value: string; label: string }[] = [
    { value: 'spam_commercial',    label: '반복 홍보, 상업적 게시물' },
    { value: 'personal_info',      label: '개인정보 노출 (실명·연락처 등)' },
    { value: 'illegal_content',    label: '불법 콘텐츠 (마약/도박/저작권 침해)' },
    { value: 'csam',               label: '아동·청소년 성착취물(CSAM)' },
    { value: 'adult_content',      label: '성인물, 선정적 콘텐츠' },
    { value: 'hate_harassment',    label: '차별/모욕/인신공격, 괴롭힘' },
    { value: 'violence_self_harm', label: '폭력/자해 위협' },
    { value: 'false_info',         label: '허위 정보' },
    { value: 'other',              label: '기타' },
  ];

  let reason = $state('spam_commercial');
  let description = $state('');
  let busy = $state(false);
  let errorMsg = $state('');

  let isValid = $derived(description.trim().length >= 20);

  async function handleSubmit() {
    if (!isValid || busy) return;
    busy = true;
    errorMsg = '';
    try {
      const res = await messages.report(targetType, targetId, reason, description.trim());
      if (res.success) {
        onSubmitted?.();
        reset();
        onClose();
      } else {
        errorMsg = res.message || '신고 접수에 실패했습니다.';
      }
    } finally {
      busy = false;
    }
  }

  function reset() {
    reason = 'spam_commercial';
    description = '';
    errorMsg = '';
  }
</script>

{#if open}
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
    <div class="w-full max-w-md rounded-2xl bg-white dark:bg-dark-secondary border border-default shadow-xl p-5">
      <div class="flex items-start justify-between mb-3">
        <h2 class="text-h2 text-content">{label ?? '신고하기'}</h2>
        <button type="button" class="p-1 rounded hover:bg-gray-100 dark:hover:bg-dark-tertiary" aria-label="닫기" onclick={onClose}>
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <p class="text-body2 text-content-tertiary mb-3">
        신고 내용은 운영팀이 검토합니다. 사유와 자세한 설명(20자 이상)을 함께 적어주세요.
      </p>

      <label for="report-reason" class="block text-body2 text-content mb-1">사유</label>
      <select id="report-reason" bind:value={reason} class="input w-full mb-3">
        {#each REASONS as r}
          <option value={r.value}>{r.label}</option>
        {/each}
      </select>

      <label for="report-desc" class="block text-body2 text-content mb-1">설명 (20자 이상)</label>
      <textarea id="report-desc"
                bind:value={description}
                class="input w-full"
                rows="4"
                maxlength="500"
                placeholder="어떤 부분이 문제인지 구체적으로 설명해주세요."></textarea>
      <p class="text-body2 text-content-tertiary mt-1">{description.length} / 500</p>

      {#if errorMsg}
        <p class="text-body2 text-error mt-2">{errorMsg}</p>
      {/if}

      <div class="mt-4 flex justify-end gap-2">
        <button type="button" class="btn btn-ghost btn-sm" onclick={onClose} disabled={busy}>취소</button>
        <button type="button" class="btn btn-primary btn-sm" onclick={handleSubmit} disabled={!isValid || busy}>
          {busy ? '제출 중...' : '신고 접수'}
        </button>
      </div>
    </div>
  </div>
{/if}
